import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-name',
  templateUrl: './brand-name.component.html',
  styleUrl: './brand-name.component.scss'
})
export class BrandNameComponent {

}
